/* The theme owns carousel navigation; this component only fits editable titles. */
if (!customElements.get('wsale-card-title')) {
  customElements.define('wsale-card-title', class extends HTMLElement {
    connectedCallback() {
      this.heading = this.querySelector('.wsale-serve__photo-title');
      this.frame = this.closest('.wsale-serve__photo-frame');
      if (!this.heading || !this.frame) return;
      this.observer = new ResizeObserver(() => this.fit());
      this.observer.observe(this.frame);
      document.fonts.ready.then(() => { if (this.isConnected) this.fit(); });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    fit() {
      const width = this.clientWidth;
      if (!width) return;
      const title = this.heading;
      const edge = this.classList.contains('wsale-serve__title-wrap--edge');
      title.style.removeProperty('--wsale-serve-title-fitted');
      const height = edge ? this.frame.clientHeight * 0.52 : this.frame.clientHeight - 48;
      let low = 10;
      let high = edge ? 160 : parseFloat(getComputedStyle(title).fontSize);
      // Measure the longest word without splitting it, then fit the wrapped block.
      title.style.overflowWrap = 'normal';
      for (let i = 0; i < 10; i++) {
        const size = (low + high) / 2;
        title.style.setProperty('--wsale-serve-title-fitted', `${size}px`);
        if (title.scrollWidth <= width && title.scrollHeight <= height) low = size;
        else high = size;
      }
      title.style.setProperty('--wsale-serve-title-fitted', `${Math.floor(low * 10) / 10}px`);
    }
  });
}
